<template>
    <form
        class="form basic-form add-friend-form"
        autocomplete="off"
        novalidate
        @submit="emitSubmit"
    >
        <div v-if="!!successMessage" class="form-message">
            {{ successMessage }}
        </div>
        <div class="form-field">
            <label class="required">Friend's email</label>
            <input
                v-model="form.email.value"
                type="email"
                placeholder="friend@example.com"
            />
            <FormError :errors="errors.email" />
        </div>
        <div class="actions">
            <Bttn id="submit-request" type="submit">Send invite</Bttn>
        </div>
    </form>
</template>

<script>
import BaseForm from "js/components/base/BaseForm.js";
import FormError from "js/components/forms/FormError";

export default {
    name: "AddFriendForm",
    components: { FormError },
    extends: BaseForm,
    data() {
        return {
            form: {
                email: { value: null },
            },
        };
    },
};
</script>
